var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { TileHeader, TileComment, Tile, TileHeaderAddButton, } from '../common/Tile';
import { useRouter } from '../../context/router-context';
import { useViewer } from '../../context/viewer-context';
import AddMemberModal from './AddMemberModal';
import { List, ListItem } from '@bootstraplabs/bsw-common-react';
import { AlertDialog } from '../common/alert-dialog';
import { refetchOrganizationsListQuery, useRemoveOrganizationMembersMutation, } from '../../__generated__/graphql';
export default function MembersTile(props) {
    var _this = this;
    var viewer = useViewer().viewer;
    // Router
    var goBack = useRouter().goBack;
    // State - dialog
    var _a = useState(false), dialogIsOpen = _a[0], setDialogIsOpen = _a[1];
    var _b = useState(null), selectedMemberId = _b[0], setSelectedMemberId = _b[1];
    // State - modal
    var _c = useState(false), modalIsOpen = _c[0], setModalIsOpen = _c[1];
    // GraphQL mutation
    var removeOrganizationMembers = useRemoveOrganizationMembersMutation({
        variables: {
            input: {
                organizationId: props.organizationId,
                memberIds: [selectedMemberId || ''],
            },
        },
        refetchQueries: [refetchOrganizationsListQuery()],
    })[0];
    if (!viewer) {
        throw new Error('Viewer not found');
    }
    // Event handlers
    var memberClick = function (id) {
        return function () {
            setSelectedMemberId(id);
            setDialogIsOpen(true);
        };
    };
    var confirmRemoveMember = function () { return __awaiter(_this, void 0, void 0, function () {
        var r;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    r = removeOrganizationMembers();
                    setDialogIsOpen(false);
                    if (selectedMemberId === viewer.id) {
                        goBack();
                    }
                    return [4 /*yield*/, r];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var cancelClick = function () {
        setDialogIsOpen(false);
    };
    var dialogDescription = function () {
        if (props.members.length === 1) {
            return 'A company needs at least one member';
        }
        if (selectedMemberId === viewer.id) {
            return 'Are you sure you want remove yourself from this company? You will lose access to the company';
        }
        var memberName = props.members.find(function (m) { return m.id === selectedMemberId; });
        return 'Remove ' + (memberName && memberName.name) + '?';
    };
    var disableDialog = props.members.length === 1;
    // Only display users that are not already a member of this org
    var users = props.users.filter(function (user) { return !props.members.some(function (member) { return member.id === user.id; }); });
    return (_jsxs(_Fragment, { children: [_jsx(AlertDialog, { "data-test": "remove-member-dialog", isOpen: dialogIsOpen, title: "Remove member", content: dialogDescription(), onBackdropClick: cancelClick, buttons: disableDialog
                    ? [
                        {
                            label: 'OK',
                            primary: true,
                            onClick: cancelClick,
                        },
                    ]
                    : [
                        {
                            label: 'Remove',
                            primary: true,
                            onClick: confirmRemoveMember,
                        },
                        {
                            label: 'Cancel',
                            onClick: cancelClick,
                        },
                    ] }, void 0),
            _jsx(AddMemberModal, { organizationId: props.organizationId, open: modalIsOpen, onCancel: function () { return setModalIsOpen(false); }, users: users }, void 0),
            _jsxs(Tile, { children: [_jsxs(TileHeader, { children: ["Members", _jsx(TileHeaderAddButton, { "data-test": "add-member-button", onClick: function () { return setModalIsOpen(true); } }, void 0)] }, void 0),
                    _jsx(TileComment, { children: "Members can edit company details on the BootstrapWorks platform" }, void 0),
                    _jsx(List, { children: props.members.map(function (_a, i) {
                            var name = _a.name, id = _a.id, emails = _a.emails;
                            return (_jsx(ListItem, { primary: name, label: emails[0].address, onClick: memberClick(id) }, i));
                        }) }, void 0)] }, void 0)] }, void 0));
}
//# sourceMappingURL=MembersTile.js.map